import React from 'react';
import Button from '../index';
import './index.css';

const WhiteButton = ({text, isDisabled, isRounded, marginVertical, marginRight, onClick}) => {
    return(
        <Button
            variant={'primary'}
            text={text}
            disabled={isDisabled}
            rounded={isRounded}
            marginVertical={marginVertical}
            marginRight={marginRight}
            _onClick={onClick}/>
    )
}

export default WhiteButton;